import camelCase from 'camelcase';

import { type CamelKeys } from '@lib/types/utils';

type AnyObject = Record<string | symbol, any>; /* need to use `any` b/c typescript chokes*/
export const camelKeys = <T extends AnyObject>(record: T): CamelKeys<T> => {
    const transformed: AnyObject = Array.isArray(record) ? [] : {};

    for (const key in record) {
        const value = record[key];
        const camelCasedKey = typeof key === 'string' ? camelCase(key) : key;

        if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
            transformed[camelCasedKey] = camelKeys(value);
        } else {
            transformed[camelCasedKey] = value;
        }
    }

    return transformed as CamelKeys<T>;
};
